import {triggerBis} from './../../../scripts/helpers/product-form'
import {validateEmail} from './../../../scripts/helpers/utils'

export default class ProductFormState {
  constructor(component) {
    this.dom = {
      $component: component,
      $triggerWaitlist: component.querySelector('.js-triggerWaitlist'),
      $successMessage: component.querySelector('.js-signUpSuccess'),
      $errorMessage: component.querySelector('.js-signUpError'),
      $form: component.querySelector('#js-soldOutSignUp'),
      $email: component.querySelector('.js-soldOutSignUpEmail'),
      $variantIdInput: document.querySelector('.js-variantId')
    }
    this.state = {
      successClass: 'success',
      errorClass: 'error'
    }
    this.checkEmailHandler = this.checkEmail.bind(this)
    this.triggerWaitlistHandler = this.triggerWaitlist.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this

    if (dom.$triggerWaitlist) {
      dom.$triggerWaitlist.addEventListener('click', this.triggerWaitlistHandler)
    }

    if (dom.$form) {
      this.attachKlaviyoForm()
      dom.$form.addEventListener('submit', this.checkEmailHandler)
    }
  }

  triggerWaitlist() {
    const {dom} = this
    const variantId = parseInt(dom.$variantIdInput.value)
    triggerBis(variantId)
  }

  attachKlaviyoForm() {
    KlaviyoSubscribe.attachToForms('#js-soldOutSignUp', {
      success: this.submitSuccess.bind(this)
    })
  }

  submitSuccess() {
    const {dom, state} = this
    dom.$form.classList.remove(state.errorClass)
    dom.$form.classList.add(state.successClass)
  }

  checkEmail(e) {
    const {dom, state} = this
    const email = dom.$email.value

    if (!email) {
      return e.preventDefault()
    }

    if (!validateEmail(email)) {
      e.preventDefault()
      dom.$form.classList.add(state.errorClass)
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductFormState = this
  }
}
